import './index.scss'
import { Controller as BaseController } from 'stimulus'
import { useCollapser } from '@app/javascript/controllers/mixins/useCollapser.js'

export class Controller extends BaseController {
  static targets = ['collapsable']

  connect() {
    this.element[this.identifier] = this
    useCollapser(this)
  }
}
